export const OTHER_CATEGORIES = 'NULL';
